__turbopack_context__.v({
  "deep": "AuroraField-module__-V6_oG__deep",
  "deepDrift": "AuroraField-module__-V6_oG__deepDrift",
  "drift-deep": "AuroraField-module__-V6_oG__drift-deep",
  "drift-warm": "AuroraField-module__-V6_oG__drift-warm",
  "field": "AuroraField-module__-V6_oG__field",
  "warm": "AuroraField-module__-V6_oG__warm",
  "warmDrift": "AuroraField-module__-V6_oG__warmDrift",
});
